import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(() => ({
  buttonSave: {
    backgroundColor: '#eee',
    border: '1px solid #54c6e8',
    color: '#54c6e8',
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    textTransform: 'none',
  },
}));

const ApplyButton = ({ children, onClick, disabled, endIcon }) => {
  const classes = useStyles();
  return (
    <Button className={classes.buttonSave} onClick={onClick} disabled={disabled} endIcon={endIcon}>
      <Typography>{children}</Typography>
    </Button>
  );
};
ApplyButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

ApplyButton.defaultProps = {};

export default ApplyButton;
